import { render, staticRenderFns } from "./ObjectEdit.vue?vue&type=template&id=0164c07d&"
import script from "./ObjectEdit.vue?vue&type=script&lang=js&"
export * from "./ObjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports